import { Trailer } from "./Trailer";
import { NumberFormatter } from "../util/NumberFormatter/NumberFormatter";
import type { PolicyAdditionalInterest } from "./PolicyAdditionalInterest";

export class PolicyAdditionalInterestLinkedTrailer implements PolicyAdditionalInterest.LinkedItem {
    id: number;
    createdDate: Date;

    trailerId: number;
    trailer?: Trailer;

    policyAdditionalInterestId: number;
    policyAdditionalInterestCreatedDate: Date;
    policyAdditionalInterest?: PolicyAdditionalInterest;

    toString(): string {
        if (this.trailer) {
            const { year, make, value, vin } = this.trailer;
            const base: (number | string)[] = [];
            if (year) base.push(year);
            if (make) base.push(make);
            if (value) base.push(NumberFormatter.Currency.format(value));
            if (vin) base.push(vin);

            return base.join(" ");
        }

        return `PolicyAdditionalInterestLinkedTrailer: ${this.trailerId}`;
    }
}
